export const hotelContentViewModel = {
    Id: true,
    Address: true,
    HotelCategory: {
        LocalizedCaption: true,
        Caption: true,
        Name: true,
        Key: true,
    },
    HotelZitoneoChange: {
        ChangeDate: true,
        SystemUser: {
            Name: true,
        },
    },
    ZitoneoContractType: {
        Name: true,
        Caption: true,
        LocalizedCaption: true,
        ContentLocalized: {
            IdContentLanguage: true,
            ContentLanguage: {
                Id: true,
                CultureId: true,
                LocalizedCaption: true,
                Caption: true,
                Name: true,
            },
            LocalizedCaption: true,
        },
    },
    ZitoneoPublishStatus: {
        ZitoneoPublishStatusType: {
            LocalizedCaption: true,
            Caption: true,
            Name: true,
            Key: true,
            Color: true,
        },
    },
    HotelCodes: {
        GiataCode: true,
    },
    Rooms: true,
    HotelServiceTypes: {
        Enabled: true,
        IdServiceType: true,
        ServiceType: {
            Enabled: true,
            Caption: true,
            LocalizedCaption: true,
            Name: true,
            IdServiceCategory: true,
            ServiceCategory: {
                Caption: true,
                LocalizedCaption: true,
                Name: true,
                Enabled: true,
                ContentLocalized: {
                    IdContentLanguage: true,
                    ContentLanguage: {
                        Id: true,
                        CultureId: true,
                        LocalizedCaption: true,
                        Caption: true,
                        Name: true,
                    },
                    LocalizedCaption: true,
                },
            },
            ContentLocalized: {
                IdContentLanguage: true,
                ContentLanguage: {
                    Id: true,
                    CultureId: true,
                    LocalizedCaption: true,
                    Caption: true,
                    Name: true,
                },
                LocalizedCaption: true,
            },
        },
        Description: true,
        Name: true,
        AttributeDefinitionEntities: {
            IdAttributeDefinition: true,
            AttributeDefinition: {
                FieldType: {
                    IsBoolean: true,
                    IsDate: true,
                    IsNumeric: true,
                    IsString: true,
                },
                MustBeUnique: true,
                AttributeDefinitionSizeType: {
                    Key: true,
                    Size: true,
                },
                IdAttributeDefinitionCategory: true,
                AttributeDefinitionCategory: {
                    Id: true,
                    Name: true,
                    Key: true,
                    Enabled: true,
                    LocalizedCaption: true,
                    Caption: true,
                },
                Name: true,
                ContentLocalized: {
                    LocalizedName: true,
                    IdContentLanguage: true,
                    ContentLanguage: {
                        Id: true,
                        CultureId: true,
                        LocalizedCaption: true,
                        Caption: true,
                        Name: true,
                    },
                },
            },
            Required: true,
            Enabled: true,
        },
        AttributeDefinitionValues: {
            IdAttributeDefinition: true,
            Value: true,
            AttributeDefinition: {
                Name: true,
                FieldType: {
                    IsBoolean: true,
                    IsDate: true,
                    IsNumeric: true,
                    IsString: true,
                },
            },
        },
        ServiceExceptions: {
            Id: true,
            IdHotelService: true,
            Active: true,
            Description: true,
            Dates: {
                Id: true,
                Active: true,
                FromDate: true,
                ToDate: true,
            },
            IdServiceExceptionLevelType: true,
            ServiceExceptionLevelType: {
                Id: true,
                Name: true,
                Caption: true,
                LocalizedCaption: true,
                Key: true,
                Icon: true,
                Color: true,
            },
        },
    },
    HotelZitoneoUrls: {
        Enabled: true,
        Id: true,
        IsPrimary: true,
        Path: true,
    },
    City: {
        Name: true,
    },
    Country: {
        Name: true,
    },
    ZitoneoMemberDate: true,
    ZitoneoMembership: true,
    HotelImages: {
        Id: true,
        Caption: true,
        VirtualPath: true,
        IdHotelImageType: true,
        HotelImageType: {
            Id: true,
            Name: true,
            Caption: true,
            LocalizedCaption: true,
            Key: true,
        },
        Feature: true,
        Published: true,
        IdHotelRoomType: true,
        IdSupplierHotelRoomType: true,
    },
    HotelRoomTypes: {
        Id: true,
        Enabled: true,
        IdMasterRoomType: true,
        MasterRoomType: {
            Id: true,
            AutoName: true,
            ManualName: true,
            SpecialRoom: true,
        },
        HotelImages: {
            Id: true,
            Caption: true,
            VirtualPath: true,
            IdHotelImageType: true,
            HotelImageType: {
                Id: true,
                Name: true,
                Caption: true,
                LocalizedCaption: true,
                Key: true,
            },
            Feature: true,
            Published: true,
            IdHotelRoomType: true,
            IdSupplierHotelRoomType: true,
        },
        SupplierRoomTypes: {
            Id: true,
            Enabled: true,
            IdSupplierHotelRoomType: true,
            SupplierHotelRoomType: {
                Id: true,
                Name: true,
                MappingCode: true,
            },
        },
        RoomTypeServices: {
            Enabled: true,
            IdServiceType: true,
            ServiceType: {
                Enabled: true,
                Caption: true,
                LocalizedCaption: true,
                Name: true,
                IdServiceCategory: true,
                ServiceCategory: {
                    Caption: true,
                    LocalizedCaption: true,
                    Name: true,
                    Enabled: true,
                    ContentLocalized: {
                        IdContentLanguage: true,
                        ContentLanguage: {
                            Id: true,
                            CultureId: true,
                            LocalizedCaption: true,
                            Caption: true,
                            Name: true,
                        },
                        LocalizedCaption: true,
                    },
                },
                ContentLocalized: {
                    IdContentLanguage: true,
                    ContentLanguage: {
                        Id: true,
                        CultureId: true,
                        LocalizedCaption: true,
                        Caption: true,
                        Name: true,
                    },
                    LocalizedCaption: true,
                },
            },

            AttributeDefinitionEntities: {
                IdAttributeDefinition: true,
                AttributeDefinition: {
                    FieldType: {
                        IsBoolean: true,
                        IsDate: true,
                        IsNumeric: true,
                        IsString: true,
                    },
                    MustBeUnique: true,
                    AttributeDefinitionSizeType: {
                        Key: true,
                        Size: true,
                    },
                    IdAttributeDefinitionCategory: true,
                    AttributeDefinitionCategory: {
                        Id: true,
                        Name: true,
                        Key: true,
                        Enabled: true,
                        LocalizedCaption: true,
                        Caption: true,
                    },
                    Name: true,
                    ContentLocalized: {
                        LocalizedName: true,
                        IdContentLanguage: true,
                        ContentLanguage: {
                            Id: true,
                            CultureId: true,
                            LocalizedCaption: true,
                            Caption: true,
                            Name: true,
                        },
                    },
                },
                Required: true,
                Enabled: true,
            },
            AttributeDefinitionValues: {
                IdAttributeDefinition: true,
                Value: true,
                AttributeDefinition: {
                    Name: true,
                    FieldType: {
                        IsBoolean: true,
                        IsDate: true,
                        IsNumeric: true,
                        IsString: true,
                    },
                },
            },
            Description: true,
        },
    },
    ZitoneoActivityLogs: {
        Agency: {
            Id: true,
            Name: true,
        },
        DateCreated: true,
        Failed: true,
        FailedMessage: true,
        Message: true,
        IdZitoneoAPIActivityType: true,
        ZitoneoAPIActivityType: {
            Color: true,
            LocalizedCaption: true,
            Caption: true,
            Name: true,
            Key: true,
        },
    },
    IdLogoFile: true,
    LogoFile: {
        Caption: true,
        VirtualPath: true,
    },
    IdZitoneoIconFile: true,
    ZitoneoIconFile: {
        Caption: true,
        VirtualPath: true,
    },
    ZitoneoScrapingExecutions: {
        Id: true,
        ExecutionDate: true,
        DateLastUpdated: true,
        Result: true,
        IdProcess: true,
        Process: {
            Id: true,
            Name: true,
            IdProcessStatus: true,
            ProcessStatus: {
                IdProcessStatusType: true,
                ProcessStatusType: {
                    Id: true,
                    Caption: true,
                    Color: true,
                    Key: true,
                },
            },
        },
        Sections: {
            Id: true,
            IdFile: true,
            File: {
                Id: true,
                Name: true,
                VirtualPath: true,
                Description: true,
            },
            IdZitoneoScrapingExecution: true,
            IdZitoneoScrapingExecutionType: true,
            ZitoneoScrapingExecutionType: {
                Id: true,
                Key: true,
            },
        },
    },
};

export const supplierHotelContentViewModel = {
    Id: true,
    IdHotel: true,
    Name: true,
    HotelOwner: {
        Name: true,
    },
    Hotel: hotelContentViewModel,
};
